import { COLORS } from '../_models/color.constants';

export function getColorLabelById(colorId: number): string {
    const color = COLORS.find((c) => c.id === colorId);
    return color ? color.label : 'Unknown';
}